import { Card, Col, Image, Row } from 'react-bootstrap';
import placeholder from '../assets/images/placeholder.jpg';
import React from 'react';
import LazyLoad from 'react-lazyload';

export interface IProduct {
  category: string,
  ean: string,
  image: string,
  name: string,
  vanprijs: number,
  sku: string,
  prijs: number,
  url: string,
};

interface Props {
  hidePrice?: boolean,
  product: IProduct,
}

const Product = (props: Props) => {
  return (
    <Col className="product mb-4">
      <Card className="h-100">
        <Card.Header className="bg-white">
          <div className="d-flex flex-row justify-content-center align-items-center h-100 w-100">
            <LazyLoad height="100%" placeholder={<Image src={placeholder} />}>
              <Image src={props.product.image}/>
            </LazyLoad>
          </div>
        </Card.Header>
        <Card.Body className="bg-light d-flex flex-column justify-content-between">
          <Row>
            <Col>
              <h6 className="text-primary card-title">{props.product.name}</h6>
            </Col>
          </Row>
          {
            !props.hidePrice &&
            <Row>
              <Col className="col d-sm-flex flex-sm-row justify-content-sm-end align-items-sm-baseline">
                {props.product.prijs < props.product.vanprijs
                  ? <hgroup className="text-primary d-flex flex-row justify-content-end mr-sm-1">
                      <h5 className="text-muted product-price-from mb-0 mb-sm-1">
                        <s>{props.product.vanprijs.toFixed(2)}</s>
                      </h5>
                    </hgroup>
                  : <></>
                }              
                <hgroup className="text-primary d-flex flex-row justify-content-end">
                  <h3 className="product-price-integer">{Math.trunc(props.product.prijs)}</h3>
                  <h3 className="product-price-separator">.</h3>
                  <h5 className="product-price-decimal">{props.product.prijs.toFixed(2).split(".")[1]}</h5>
                </hgroup>
              </Col>
            </Row>
          }
        </Card.Body>
        <Card.Footer className="text-center bg-secondary p-0">
          <a href={props.product.url} className="btn btn-secondary btn-block text-white stretched-link p-2" target="_blank" rel="noopener noreferrer" role="button">Bestel nu</a>
        </Card.Footer>
      </Card>
    </Col>
  );
}

export default Product;